import home from './src/home.vue'
import WifiDeviceManagerView from './src/WifiDeviceManage/WifiDeviceManagerView.vue' //Wifi设备列表
import WifiDeviceManagerEdit from './src/WifiDeviceManage/WifiDeviceManagerEdit.vue' //Wifi设备详情
import WifiRealtimeVisitorListView from './src/WifiRealtimeVisitor/WifiRealtimeVisitorListView.vue' //Wifi在线用户信息
import WifiUserAnalysisView from './src/WifiUserAnalysis/WifiUserAnalysisView.vue'  //Wifi用户分析

let views = {
    home,
    WifiDeviceManagerView,
    WifiDeviceManagerEdit,
    WifiRealtimeVisitorListView,
    WifiUserAnalysisView
};

export default views;